import {useQuery} from '@tanstack/react-query';

import {Event} from '@entities/event/types';
import {GetListOutput} from '@shared/api';
import {getTopicEvents, GetTopicEventsParams} from '../api';
import {QUERY__TOPIC_EVENTS} from '../queryKeys';

import {QueryOptionsForList} from '@/shared/api';

export const useGetTopicEvents = <SelectedData = GetListOutput<Event>>(
  params: GetTopicEventsParams,
  options?: QueryOptionsForList<Event, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__TOPIC_EVENTS, params],
    queryFn: () => getTopicEvents(params),
    ...options,
  });
};
